var map = {
	"./BB1.jpg": "jw03",
	"./BB2.jpg": "FKvq",
	"./BB3.jpg": "tQJd",
	"./BB4.jpg": "tOho",
	"./BB5.jpg": "njpA",
	"./OH1.jpg": "eCLb",
	"./OH2.jpg": "w34F",
	"./OH6.jpg": "D4aR",
	"./VS1.jpg": "nl+g",
	"./VS2.jpg": "VHKy",
	"./VS3.jpg": "UVvP",
	"./VS4_VS5.jpg": "To1N",
	"./VS6.jpg": "8ViO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vvha";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.jpg$
// module id = vvha
// module chunks = 1